import React, { Component } from "react";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Divider from "@material-ui/core/Divider";

import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import {
  DRAWER_WIDTH,
  ACCOUNTS_TOOLBAR_HEIGHT,
  ACCOUNTS_TOOLBAR_TOP,
  MAIN_CONTENT_TOP,
} from "../components/Constants";
import { getErrorString } from "../display/ErrorStrings";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },

  toolbar: {
    height: `${ACCOUNTS_TOOLBAR_HEIGHT / 2}px`,
    zIndex: 1,
    position: "fixed",
    top: `${ACCOUNTS_TOOLBAR_TOP + ACCOUNTS_TOOLBAR_HEIGHT + 10}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
  },

  tableWrapper: {
    overflowX: "auto",
    overflowY: "auto",

    position: "fixed",
    top: `${MAIN_CONTENT_TOP + ACCOUNTS_TOOLBAR_HEIGHT / 2}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
    bottom: "0px",
  },
});

const columnData = [
  {
    id: "serviceType",
    numeric: false,
    disablePadding: true,
    label: "Service Type",
  },
  {
    id: "servicename",
    numeric: false,
    disablePadding: true,
    label: "Service Name",
  },
  {
    id: "billingplanname",
    numeric: false,
    disablePadding: true,
    label: "Plan Name",
  },
  { id: "flatrate", numeric: false, disablePadding: true, label: "Flat Rate" },
  {
    id: "addfee",
    numeric: false,
    disablePadding: true,
    label: "Extra Item Fee",
  },
  {
    id: "numincluded",
    numeric: false,
    disablePadding: true,
    label: "Number Included Items",
  },
  { id: "freq", numeric: false, disablePadding: true, label: "Frequency" },
];

const columnData2 = [
  {
    id: "serviceType",
    numeric: false,
    disablePadding: true,
    label: "Service Type",
  },
  {
    id: "servicename",
    numeric: false,
    disablePadding: true,
    label: "Service Name",
  },
];

class BillingInfoPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      totalCount: 0,
      notifyString: "",
      definedServicesCount: 0,
      changedServicesCount: 0,
      undefinedServicesCount: 0,
      definedServices: [],
      changedServices: [],
      undefinedServices: [],
      viewPopup: false,
    };
  }

  handleContinue(e) {
    this.props.history.push("/main");
  }
  componentDidMount() {
    fetch("on_billing_info", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        transit: this.props.accountObject.transit,
        account: this.props.accountObject.account,
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
          this.setState({ viewPopup: true });
        } else {
          this.setState({ totalCount: reply.totalCount });
          if (reply.totalCount === 0) {
            this.setState({
              notifyString:
                "There is no service under this account. Please add services for it first.",
            });
          } else {
            this.setState({ definedServicesCount: reply.definedServicesCount });
            this.setState({ definedServices: reply.definedServices });
            this.setState({
              undefinedServicesCount: reply.undefinedServicesCount,
            });
            this.setState({ undefinedServices: reply.undefinedServices });
            this.setState({ changedServicesCount: reply.changedServicesCount });
            this.setState({ changedServices: reply.changedServices });
          }
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ totalCount: 0 });
        this.setState({ viewPopup: true });
      });
  }

  render() {
    const { classes } = this.props;
    let data = this.state.definedServices;
    let data2 = this.state.changedServices;
    let data3 = this.state.undefinedServices;
    let { t } = this.props;

    return (
      <div>
        <div className={classes.toolbar}>
          {this.state.errorString.length > 0 && (
            <Typography color="error" variant="h6">
              &nbsp;&nbsp;{this.state.errorString}
            </Typography>
          )}
          {this.state.notifyString.length > 0 && (
            <Typography color="primary" variant="subheading">
              &nbsp;&nbsp;{this.state.notifyString}
            </Typography>
          )}
          {this.state.totalCount > 0 && (
            <Typography color="default" variant="h6">
              &nbsp;&nbsp;{t("billingInformation.label")}{" "}
              {this.state.totalCount}
            </Typography>
          )}
        </div>
        <div className={classes.tableWrapper}>
          {this.state.definedServicesCount > 0 && (
            <Paper className={classes.root} elevation={6}>
              <Typography color="primary" variant="h6">
                &nbsp;&nbsp;{t("currentBillingPlan.label")}&nbsp;&nbsp;
              </Typography>
              <Table>
                <TableHead>
                  <TableRow>
                    {columnData.map((column) => {
                      return (
                        <TableCell
                          key={column.id}
                          numeric={column.numeric}
                          padding={column.disablePadding ? "none" : "default"}
                        >
                          {column.label}
                        </TableCell>
                      );
                    }, this)}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.map((item) => {
                    return (
                      <TableRow key={item.id}>
                        <TableCell component="th" scope="row">
                          {item.type}
                        </TableCell>
                        <TableCell>{item.name}</TableCell>
                        <TableCell>{item.billingInfo.planName}</TableCell>
                        <TableCell>{item.billingInfo.flatRate}</TableCell>
                        <TableCell>{item.billingInfo.perItem}</TableCell>
                        <TableCell>{item.billingInfo.numFree}</TableCell>
                        <TableCell>{item.billingInfo.freq}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Paper>
          )}

          {this.state.changedServicesCount > 0 && (
            <Paper className={classes.root} elevation={6}>
              <Divider />
              <Typography color="primary" variant="subheading">
                &nbsp;&nbsp;{t("billingPlanChanged.label")}
              </Typography>
              <Table>
                <TableHead>
                  <TableRow>
                    {columnData.map((column) => {
                      return (
                        <TableCell
                          key={column.id}
                          numeric={column.numeric}
                          padding={column.disablePadding ? "none" : "default"}
                        >
                          {column.label}
                        </TableCell>
                      );
                    }, this)}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data2.map((item) => {
                    return (
                      <TableRow key={item.id}>
                        <TableCell component="th" scope="row">
                          {item.type}
                        </TableCell>
                        <TableCell>{item.name}</TableCell>
                        <TableCell>{item.billingInfo.planName}</TableCell>
                        <TableCell>{item.billingInfo.flatRate}</TableCell>
                        <TableCell>{item.billingInfo.perItem}</TableCell>
                        <TableCell>{item.billingInfo.numFree}</TableCell>
                        <TableCell>{item.billingInfo.freq}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Paper>
          )}

          {this.state.undefinedServicesCount > 0 && (
            <Paper className={classes.root} elevation={6}>
              <Divider />
              <Typography color="primary" variant="subheading">
                &nbsp;&nbsp;{t("unknowBillingPlan.label")}
              </Typography>
              <Table>
                <TableHead>
                  <TableRow>
                    {columnData2.map((column) => {
                      return (
                        <TableCell
                          key={column.id}
                          numeric={column.numeric}
                          padding={column.disablePadding ? "none" : "default"}
                        >
                          {column.label}
                        </TableCell>
                      );
                    }, this)}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data3.map((item) => {
                    return (
                      <TableRow key={item.id}>
                        <TableCell component="th" scope="row">
                          {item.type}
                        </TableCell>
                        <TableCell>{item.name}</TableCell>
                        <TableCell colSpan={5}></TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Paper>
          )}
        </div>
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(BillingInfoPage));
